import React from 'react';

import {addClass, removeClass} from 'rendering-commons';

export default class FlashScore extends React.Component {
    static propTypes = {
        scoreString: React.PropTypes.string.isRequired,
        languageId: React.PropTypes.number.isRequired
    };

    constructor(props) {
        super(props);

        this._timeoutId = null;
    }

    shouldComponentUpdate(nextProps) {
        return this.props.scoreString !== nextProps.scoreString;
    }

    componentDidUpdate(prevProps) {
        if (this.props.languageId !== prevProps.languageId) {
            return;
        }

        const element = this.refs.scores;

        if (!element) {
            return;
        }

        const className = 'changed-score';

        addClass(element, className);

        this._timeoutId = window.setTimeout(this._onTimeout.bind(this, element, className), 2000);
    }

    componentWillUnmount() {
        if (this._timeoutId !== null) {
            window.clearTimeout(this._timeoutId);
        }
    }

    _onTimeout(element, className) {
        removeClass(element, className);
        this._timeoutId = null;
    }

    render() {
        const {scoreString} = this.props;

        return (
            <span ref="scores" className="score full">
                {scoreString}
            </span>
        );
    }
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/components/matchStats/FlashScore.jsx